<template>
    <b-container
            v-if="isLoaded"
            class="relais mx-lg-auto px-0 d-flex flex-column"
    >
        <b-card
                class="relais--card"
                :class="{'br-4 block--shadow border-0 wr-header': isDesktop}"
        >
            <header class="relais--header pb-0">
                <h1 class="relais--title pb-1">
                    <i class="fas fa-child"></i>
                    Page Coach Référent Alter Ego Digital
                </h1>
                <div class="row no-gutters relais--info">
                    <div class="col-1 px-0">
                        <i class="fas fa-info-circle"></i>
                    </div>
                    <div class="col-11 px-0">
                        <p class="mb-0">
                            Depuis cette page, gérez vos séances,
                            vos conversations avec les salariés relais ainsi que vos rappels
                            ...
                        </p>
                    </div>
                    <div class="col-12">
                        <b-form-select
                                :options="organisations"
                                @change="changeOuId($event)"
                                v-model="organisationId"
                        />
                    </div>
                </div>
            </header>
        </b-card>
        <main
                class="relais-main flex-grow-1 d-flex flex-column"
                id="roadlog-container"
                :class="{'br-4 block--shadow border-0': isDesktop}"
        >
            <div class="relais--tab d-flex flex-column flex-grow-1 pt-1">
                <div class="relais--tab-card flex-grow-1 d-flex flex-column p-0">
                    <b-card-header class="p-0 relais--tab-header" header-tag="nav">
                        <b-nav tabs fill class="relais--tab-nav">
                            <b-nav-item
                                    class="relais--tab-nav-item px-0"
                                    v-on:click="tab = 'meetings'"
                                    :active="tab === 'meetings'"
                            >
                                <i class="fas fa-users"/>
                                Séances
                                <span
                                        v-if="counts.meetingType > 0"
                                        class="alert--indicator"
                                >
                                    {{counts.meetingType}}
                                </span>
                            </b-nav-item>
                            <b-nav-item
                                    class="relais--tab-nav-item px-0"
                                    v-on:click="tab = 'relais'"
                                    :active="tab === 'relais'"
                            >
                                <i class="fas fa-comments"/>
                                Salariés relais
                                <span
                                        v-if="counts.threads.length > 0"
                                        class="alert--indicator"
                                >
                                    {{counts.threads.length}}
                                </span>
                            </b-nav-item>
                            <b-nav-item
                                    class="relais--tab-nav-item px-0"
                                    v-on:click="tab = 'reminders'"
                                    :active="tab === 'reminders'"
                            >
                                <i class="fas fa-bullhorn"/>
                                Rappels
                                <span
                                        v-if="counts.reminders > 0"
                                        class="alert--indicator"
                                >
                                    {{counts.reminders}}
                                </span>
                            </b-nav-item>
                        </b-nav>
                    </b-card-header>
                    <b-card-body class="relais--tab--body flex-grow-1 flex-column px-0 bg-whitesmoke">
                        <div
                                class="relais--tab--body-meetings d-flex flex-column"
                                v-if="tab === 'meetings' && seanceTypes.actives && seanceTypes.incoming"
                        >
                            <h2 class="pt-2">Séances types proposées</h2>
                            <template v-if="seanceTypes.actives.length > 0">
                                <h3 class="relais--tab--body-title">Séances disponibles</h3>
                                <meeting-type-detail
                                        v-for="(meeting, index) of seanceTypes.actives"
                                        :meeting-type="meeting"
                                        :key="`meeting-type-active-${index}`"
                                />
                            </template>
                            <template v-if="seanceTypes.incoming.length > 0">
                                <h3 class="relais--tab--body-title">Séances en cours de préparation</h3>
                                <meeting-type-detail
                                        v-for="(meeting, index) of seanceTypes.incoming"
                                        :meeting-type="meeting"
                                        :key="`meeting-type-incoming-${index}`"
                                />
                            </template>
                            <template v-if="seanceTypes.actives.length === 0 && seanceTypes.incoming.length === 0">
                                <p show class="text-center py-3">
                                    Aucune séance n'est diponible pour le moment
                                </p>
                            </template>
                            <b-btn
                                    block
                                    variant="link"
                                    :to="{name: 'meeting-type-new', query: {ouId: queryOuId}}"
                                    v-if="programs.length > 0"
                            >
                                <i class="fas fa-plus"/>
                                Nouvelle séance
                            </b-btn>
                        </div>
                        <div
                                class="relais--tab--body-coaches d-flex flex-grow-1 flex-column"
                                v-else-if="tab === 'relais'"
                        >
                            <thread-new
                                    v-if="threadMode === 'new'"
                                    :users="users"
                                    :thread-type="coachCallType"
                                    multiple
                                    @new="reloadThreads($event)"
                                    @cancel="threadMode = 'list'"
                                    class="flex-grow-1"
                            />
                            <thread-detail
                                    v-if="queryThreadId && threadMode === 'view'"
                                    :thread-id="queryThreadId"
                                    @click="pickThread($event)"
                            />
                            <template
                                    v-else-if="threadMode === 'list'"
                            >
                                <thread-list
                                        class="flex-grow-1"
                                        @change="pickThread($event)"
                                />
                                <div>
                                    <hr class="mb-0 mx-2"/>
                                    <b-btn
                                            @click="threadMode = 'new'"
                                            class="cursor--pointer"
                                            variant="link"
                                            block
                                    >
                                        <i class="fas fa-plus"/>
                                        Nouvelle conversation
                                    </b-btn>
                                </div>
                            </template>
                        </div>
                        <div
                                class="relais--tab--body-reminders"
                                v-else-if="tab === 'reminders'"
                        >
                            <h2 class="py-2">
                                Vos rappels et informations
                                <a href="#"><i class="fas fa-info-circle"></i></a>
                            </h2>
                            <roadlog-reminder
                                    v-for="(reminder, index) of reminders"
                                    :key="`roadlog-referent-reminder-${index}`"
                                    :reminder="reminder"
                            />
                            <p class="text-center py-3" v-if="reminders.length === 0">
                                Vous n'avez aucun rappels à effectuer pour le moment
                            </p>
                        </div>
                    </b-card-body>
                </div>
            </div>
        </main>
    </b-container>
</template>

<style lang="scss" scoped>
    .relais--tab--body-title{
        font-size: 1.2em;
        font-weight: bold;
        padding: 1em 0.3em 1em 0.3em;
    }
    @media screen and (min-width: 1280px) {
        .relais{
            max-width: 1140px;
        }
    }

</style>

<script>
    import NavigationTabs from "../../components/navigation/Tabs";
    import ThreadList from "../../components/thread/List";
    import ThreadDetail from "../../components/thread/Detail";
    import MeetingTypeDetail from "../../components/meetingType/Detail";
    import ThreadNew from "../../components/thread/New";
    import ProgramDetail from "../../components/program/Detail";
    import moment from 'moment'
    import RoadlogReminder from "../../components/roadlog/Reminder";

    export default {
        name: 'ReferentRoadlog',
        components: {
            RoadlogReminder,
            ProgramDetail,
            ThreadNew,
            MeetingTypeDetail,
            ThreadDetail,
            ThreadList,
            NavigationTabs
        },
        data: () => ({
            moment,
            tab: 'meetings',
            threadMode: 'list',
            loaded: [],
            organisationId: null,
            isLoaded: false,
            isDesktop: window.innerWidth > 768
        }),
        async mounted() {
            this.tab = this.queryTab
            this.changeOuId(this.queryOuId)
            await this.loadCounts()
            if (this.queryThreadId) {
                this.tab = 'relais'
                this.threadMode = 'view'
            } else {
                this.loadMeetings()
            }
            this.isLoaded = true
        },
        methods: {
            updateQuery(params) {
                const route = {query: {}}
                for (const prop in params) if (params.hasOwnProperty(prop)) route.query[prop] = params[prop]
                this.$router.push(route)
            },
            pickThread(threadId) {
                this.queryThreadId === threadId ?
                    this.updateQuery({ouId: this.queryOuId}) :
                    this.updateQuery({threadId: threadId, ouId: this.queryOuId})
                this.threadMode = this.threadMode === 'view' ? 'list' : 'view'
            },
            changeOuId(ouId = null) {
                ouId === null ? this.updateQuery({ouId: this.organisations[0].value}) : this.updateQuery({ouId: ouId})
                this.organisationId = this.queryOuId
            },
            async reloadThreads(threadId = null) {
                await this.$store.dispatch('base/thread/list', this.queryOuId)
                if (threadId !== null)
                    this.pickThread(threadId)
            },
            async loadMeetings() {
                await Promise.all([
                    this.$store.dispatch('base/seanceType/ous', [this.queryOuId]),
                    this.$store.dispatch('base/program/ou', this.queryOuId),
                ])
            },
            async loadRelais() {
                const promises = [
                    this.$store.dispatch('base/organisation/role', {
                        role: 'ROLE_WORKER_RELAIS',
                        ous: this.queryOuId
                    }),
                    this.reloadThreads()
                ]
                if (this.threadTypes.length === 0) promises.push(this.$store.dispatch('base/thread/type/list'))
                await Promise.all(promises)
            },
            async loadReminders() {
                await Promise.all([
                    this.$store.dispatch('base/program/visMaVieOu', this.organisationId),
                ])
            },
            loadByTab() {
                if (!this.loaded.includes(this.tab)) {
                    switch (this.tab) {
                        case 'meetings':
                            this.loadMeetings()
                            break
                        case 'relais':
                            this.loadRelais()
                            break
                        case 'reminders':
                            this.loadReminders()
                            break
                    }
                    this.loaded.push(this.tab)
                }
            },
            async loadCounts() {
                await this.$store.dispatch('base/appInterface/roadlog', {
                    role: 'ROLE_COACH_REFERENT',
                    ouId: this.organisationId
                })
            }
        },
        computed: {
            threads() {
                return this.$store.state.base.thread.threads
            },
            organisations() {
                const organisations = []
                for (const ou of this.$store.state.base.account.ousReferent) {
                    organisations.push({
                        value: ou.id,
                        text: ou.fullName
                    })
                }
                return organisations.sort((a, b) => {
                    return b.fullName - a.fullName
                })
            },
            queryThreadId() {
                return this.$route.query.threadId ?
                    parseInt(this.$route.query.threadId) :
                    undefined
            },
            queryOuId() {
                return this.$route.query.ouId ?
                    parseInt(this.$route.query.ouId) :
                    this.organisations[0].value
            },
            queryTab() {
                return this.$route.query.tab ? this.$route.query.tab : 'meetings'
            },
            users() {
                return this.$store.state.base.organisation.usersByRole
            },
            seanceTypes() {
                return this.$store.state.base.seanceType.seanceTypes
            },
            threadTypes() {
                return this.$store.state.base.thread.type.types
            },
            coachCallType() {
                return this.threadTypes.filter((t) => {
                    return t.value === 'coach_call'
                })[0]
            },
            todoPrograms() {
                return this.$store.state.base.program.visMaVieOu
            },
            programs() {
                return this.$store.state.base.program.ou
            },
            reminders() {
                let reminders = []
                const immersion = this.todoPrograms
                const ou = this.$store.state.base.account.ousReferent.find((ou) => {
                    return ou.id === this.organisationId
                })
                reminders = reminders.concat(immersion.map((i) => {
                    return {
                        name: 'Vis ma vie à effectuer',
                        info: `À ${ou.fullName}`,
                        icon: 'fas fa-child',
                        isImportant: true,
                        date: moment(i.programmeEtapes[0].date.date).format('[Le] DD/MM/YYYY'),
                        button: {
                            label: 'Effectuer le vis ma vie',
                            route: {
                                name: 'program-visMaVie',
                                query: {
                                    program: i.id,
                                    ou: ou.id
                                }
                            }
                        }
                    }
                }))
                return reminders
            },
            counts() {
                return this.$store.state.base.appInterface.roadlog
            },
            user() {
                return this.$store.state.base.account.information
            }
        },
        watch: {
            async queryOuId() {
                this.loaded = []
                await this.loadCounts()
                this.loadByTab()
            },
            tab() {
                this.loadByTab()
            }
        }
    }
</script>
